<template>
    <div>
        <v-card class="mt-8 mx-8 pa-4">
            <v-card-actions class="text-left">
                <v-row>
                    <v-col cols="12" class="text-left">
                        <v-icon class="back-link-icon" x-large @click="$router.push('/item-files/index')">
                            mdi-arrow-left
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-card-title>ساخت فایل درسی جدید</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="3">
                        <v-text-field color="black" v-model="itemFile.title" label="عنوان"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-select label="دسته بندی" :items="categories" item-text="label" item-value="id"
                                  color="black" v-model="itemFile.category_id">
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select label="وضعیت نمایش"
                                  :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                                  color="black" v-model="itemFile.visibility">
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select label="نوع فایل" :items="fileTypes"
                                  color="black" v-model="itemFile.mime_type">
                        </v-select>
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete :items="covers" item-text="tag" item-value="id" v-model="itemFile.cover_id"
                                        label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="فایل"
                                      @click="mainFileDialog = true" prepend-icon="mdi-plus"
                                      color="black"
                                      v-model="itemFile.file"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-textarea color="black" v-model="itemFile.description" label="توضیحات فایل درسی"></v-textarea>
                    </v-col>
                    <v-col cols="6">
                        <v-textarea color="black" v-model="itemFile.comment" label="دست نوشته فایل درسی"
                                    hint="این نوشته سمت کاربر نمایش داده نمی شود و فقط برای یادداشت شما می باشد که در جستجو از آن استفاده کنید."></v-textarea>
                    </v-col>
                    <v-col cols="12" class="activity-tags-section-title">
                        تگ های فعالیت
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="itemFile.activity_tag_ids"
                            :items="activityTags"
                            item-text="title"
                            item-value="id"
                            label="تگ های فعالیت"
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            color="black"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="mainFileDialog" max-width="50vw">
            <drag-and-drop module="itemFile" ref="image-uploader"
                           @closeUploadFileDialog="mainFileDialog = false"
                           @changeFile="itemFile.file = $event"></drag-and-drop>
        </v-dialog>
    </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
    name: "ItemFileCreate",
    components: {DragAndDrop},
    data() {
        return {
            covers: [],
            mainFileDialog: false,
            categories: [],
            activityTags: [],
            fileTypes: [
                {text: 'ویدیو', value: 'video'},
                {text: 'تصویر', value: 'image'},
                {text: 'پی دی اف', value: 'pdf'},
                {text: 'صوتی', value: 'audio'},
                {text: 'نوشته', value: 'text'},
                {text: 'غیره', value: 'other'}
            ],
            itemFile: {
                title: null,
                category_id: null,
                visibility: null,
                description: null,
                file: null,
                cover_id: null,
                mime_type: null,
                comment: null,
                activity_tag_ids: [],
            }
        }
    },
    mounted() {
        this.getCategories()
        this.getCovers()
        this.getActivityTags()
    },
    methods: {
        getActivityTags() {
            window.axios.get('course/activity-tag/index?per_page=10000').then((res) => {
                this.activityTags = res.data.data.data
            })
        },
        getCovers() {
            window.axios.get('file-manager/cover/index?type=item_file&per_page=10000').then((res) => {
                this.covers = res.data.data.data
            })
        },
        store() {
            window.axios.post('course/item-file/create', this.itemFile).then(() => {
                this.openSnackbar("فایل درسی جدید با موفقیت ساخته شد.", 'success')
            }).catch((err) => {
                if (err.response.status === 422) {
                    this.showValidationErrors(err, '#F1416C')
                } else if (err.response.status === 400) {
                    this.openSnackbar(err.response.data.message, '#F1416C')
                }
            })
        },
        clear() {
            this.itemFile = {
                category_id: null,
                visibility: null,
                title: null,
                description: null,
                file: null,
                cover_id: null,
                mime_type: null,
                comment: null,
                activity_tag_ids: [],
            }
        },
        getCategories() {
            window.axios.get('category/index?per_page=1000&type=item_file').then((res) => {
                this.categories = res.data.data.data
            })
        },
    }
}
</script>

<style>
.back-link-icon {
    color: #413e3e !important;
}

.back-link-icon:hover {
    color: orangered !important;
}

.normal-font-btn {
    letter-spacing: normal !important;
}

.activity-tags-section-title {
    font-weight: 700;
    text-align: right;
}
</style>
